export default __webpack_public_path__ + "static/media/humidity-active.0d4bd7d2.svg";